<!--
 * @Author: 仙道
 * @Date: 2023-05-04 21:38:50
 * @LastEditTime: 2023-05-05 21:21:17
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/duty/modules/YwDutyRecordFormModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <!-- <yw-duty-record-form :disabled="disableSubmit"   ref="realForm"></yw-duty-record-form> -->
    <OperationRecord ref="realForm" @ok="submitCallback"></OperationRecord>
  </j-modal>
</template>

<script>
import YwDutyRecordForm from './YwDutyRecordForm'
import OperationRecord from './OperatorRecordForm.vue'

export default {
  name: 'YwDutyRecordModal',
  components: {
    YwDutyRecordForm,
    OperationRecord
  },
  data() {
    return {
      title: '',
      width: 1100,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    add() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add()
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.bizId = record.id
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitData()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-modal-body {
  max-height: calc(80vh - 150px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e3e3e6;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 5px;
  }
}
</style>
